import { render, staticRenderFns } from "./PerfilEsqueceuSenha.vue?vue&type=template&id=09dad438&scoped=true"
import script from "./PerfilEsqueceuSenha.vue?vue&type=script&lang=js"
export * from "./PerfilEsqueceuSenha.vue?vue&type=script&lang=js"
import style0 from "./PerfilEsqueceuSenha.vue?vue&type=style&index=0&id=09dad438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dad438",
  null
  
)

export default component.exports